/**
 * Pod-scoped slice of the global event stream.
 *
 * Events are tagged at replica granularity (all pods of a replica
 * share the same event stream), so we lock the filter to
 * `replica_id` and keep `service_id` / `pool_id` in the chain for
 * symmetry with the Global Events deep-link URL contract.
 */
import { EventsStream } from "@/components/EventsStream";
import type { Pool, Replica, Service } from "@/api/types";

interface Props {
  replica: Replica;
  pool: Pool;
  service: Service;
}

export function PodEvents({ replica, pool, service }: Props) {
  return (
    <EventsStream
      lockedScope={{
        service_id: service.id,
        pool_id: pool.id,
        replica_id: replica.id,
      }}
    />
  );
}
